export default {
  challenges: 'Desafíos',
  home: 'Inicio',
  library: 'Biblioteca',
  logout: 'Salir',
  store: 'Tienda'
}
  